<template>
  <Dashboard/>
</template>

<style lang="scss">
* {
  font-family: $font-family-inter;
  ::-webkit-scrollbar {
    display: none;
  }
}
body{
  overflow: hidden;
}
</style>
